import { Component, Injectable, OnInit, Input, ElementRef, ViewChild , TemplateRef, EventEmitter, Output} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { Select2TemplateFunction, Select2OptionData } from 'ng2-select2';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { UserService } from '../../../../../common/services/User.service';
import * as _ from 'lodash';
import { FieldService } from '../../../../../common/services/Field.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { CommentService } from '../../../../../common/services/Comment.service';
import { UtilityService } from 'app/common/services/Utility.service';

declare var $: any;
declare const Timer: any;

@Component({
    moduleId: module.id,
    selector: "detail-organize",
    templateUrl: './detail_organize.component.html',
    styleUrls: ['../detail.css', './organize.css'],
    providers: [BsModalService, GroupService, OrganizeService, EvsAddressService,
        UserService, FieldService, CommentService]
})

@Injectable()
export class DetailOrganizeComponent implements OnInit {
    @Input() organize;
    public no_image: any = 'assets/images/contact.png';

    @Output('comeback') comeback = new EventEmitter();
    public user: any;
    public message: { class: string, content: string } = null;

    public allStatus: any = [];
    public status_select2: any = [{ id: '', text: '' }]
    public allFillterGroup: any = [{ id: '', text: '' }];

    public modalRef: any;
    public model: any = {tags:[]};
    public modelGroup: any = {};
    public modelOrganize: any = {};
    public fields: any = [];

    public change_name: boolean = false;
    public tab: string = 'ticket';

    public tickets: any = {};
    public currentPage: any = {};
    public totalItem: any = {};
    public totalPage: any = {};
    public page_size: number = 10;
    public is_loading: boolean = false;
    public filter_type: any = 'request' //request | assign || reciver
    public total : number = 0;

    public selected : any = {};
    public fast_status: any;
    public show_action_ticket : boolean = false; //chọn ticket thì mới show, ko thì thoi 


    public modelFilter: any = {};
    public listAgent : any = [];
    public totalItem1: any = 0;
    public totalPage1: any = 0;
    public page_size1: number = 5;
    public currentPage1: number = 1;


    public listUser : any = [];
    public totalItem2: any = 0;
    public totalPage2: any = 0;
    public page_size2: number = 10;
    public currentPage2: number = 1;

    public detailTicket: any = {}

    constructor(
        private toastr: ToastrService,
        private groupService: GroupService,
        private organizeService: OrganizeService,
        private addressService: EvsAddressService,
        private modalService: BsModalService,
        private userService: UserService,
        private fieldService: FieldService,
        private ticketService: TicketService,
        private socketService: SocketService,
        private commentService: CommentService
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.listTicket();
    }

    ngAfterViewInit() {
        setTimeout(function () {
            if(this.organize.tags && typeof(this.organize.tags) == 'object'){
                this.organize.tags_string = this.organize.tags.join(",");
            } else {
                this.organize.tags_string = this.organize.tags;
            }
            this.model = _.assign({}, this.organize);
            if (this.model.tags_string && typeof this.model.tags_string == 'string') {
                let arr_tags = this.model.tags_string.split(',');
                arr_tags = _.map(arr_tags, e => {
                    return {
                        displayValue: e
                    }
                })
                this.model.tags = arr_tags;
            }else this.model['tags'] = [];
        }.bind(this), 200);
    }

    changeTab(tab) {
        this.tab = tab;
        this.totalItem1 = 0;
        this.totalPage1 = 0;
        this.currentPage1 = 0;
        if(tab == 'ticket') {
            this.listTicket();
        }else {
            this.loadUsers();
        }
    }
   
    loadUsers(request: any = {}, sort: any = {}) {
        this.is_loading = true;
        this.listUser = [];
        request.offset = this.page_size2 * (this.currentPage2 <= 0 ? 0 : this.currentPage2 - 1);
        request.limit = this.page_size2;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        request.filters = JSON.stringify([{
            key:'organize_id',
            condition : '=',
            value: this.organize.organize_id
        }]);
        this.userService.usersAllRole(request).subscribe(res =>{
            if (res.status == 200 && res.error == false) {
                this.listUser = res.data.list;
                this.totalItem2 = res.data.total;
                var pageString = (this.totalItem2 / this.page_size2).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage2 = totalpage;


            } else {
                this.listUser = [];
            }
            this.is_loading = false;
        })
    }

    openUser(user) {
        this.socketService.opentab(user,'user','edit');
    }

    hover(item) {
        this.detailTicket = item;
        this.commentService.list({where: JSON.stringify({ticket_id: this.detailTicket._id}), limit:1}).subscribe(res => {
            if (res.status == 200 && res.error == false && res.data.comments) {
                this.detailTicket['lastest_comment'] = res.data.comments[0] ? res.data.comments[0] : null;
            }
        })
    }

    openModal(template: TemplateRef<any>, id?:any) {
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
    }

    onSelect(status, ticket_id?:any) {
        if(ticket_id) {
            this.selected[status][ticket_id] = this.selected[status][ticket_id]? false : true;
        }else {
            let check = $('#checkbox-'+status).is(':checked');
            this.tickets[status].forEach(e => {
                this.selected[status][e._id] = check;
            });
        }
        this.show_action_ticket = false;
        this.allStatus.forEach(status => {
            if(this.tickets[status.id]) {
                this.tickets[status.id].forEach(e => {
                    if(this.selected[status.id][e._id]){
                        this.show_action_ticket = true;
                    }
                });
            }
        });
    }

    unSelect() {
        this.show_action_ticket = false;
        this.allStatus.forEach(status => {
            if(this.tickets[status.id]) {
                this.tickets[status.id].forEach(e => {
                    this.selected[status.id][e._id] = false;
                });
            }
        });
    }

    changeFastStatus(e:any) {
        this.fast_status = e.value;
    }

    submitFastStatus() {
        let ids = [];
        this.allStatus.forEach(status => {
            if(this.tickets[status.id]) {
                this.tickets[status.id].forEach(e => {
                    if(this.selected[status.id][e._id]){
                        ids.push(e._id);
                    }
                });
            }
        });
        this.ticketService.updateMany({_id:{$in: ids}}, {status: parseInt(this.fast_status)}).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Chuyển trạng thái không thành công" };
                    this.toastr.error('Chuyển trạng thái không thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Chuyển trạng thái thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.modalRef.hide();
                    this.listTicket();
                    this.unSelect();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        })
    }

    changedFilterGroup(e) {
        this.modelFilter.group_id = e.value;
    }

    filterAgent() {
        let options = [];
        if (this.modelFilter.filter_agent_phone) {
            options.push({
                key: 'phone',
                condition :'=',
                value : this.modelFilter.filter_agent_phone
            })
        }
        if (this.modelFilter.group_id) {
            options.push({
                key: 'group_id',
                condition :'=',
                value : this.modelFilter.group_id
            })
        }
        this.getStaffs({filters: JSON.stringify(options)});
    }

    assignTickets(user_id, group_id?:any) {
        let ids = [];
        this.allStatus.forEach(status => {
            if(this.tickets[status.id]) {
                this.tickets[status.id].forEach(e => {
                    if(this.selected[status.id][e._id]){
                        ids.push(e._id);
                    }
                });
            }
        });

        let payload = {assign_agent_id: user_id};
        if(group_id) {
            payload['assign_group_id'] = group_id;
        }
        this.ticketService.updateMany({_id:{$in:ids}}, payload).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Chuyển không thành công" };
                    this.toastr.error('Chuyển không thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Chuyển thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.listTicket();
                    this.unSelect();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        })
    }

    getStaffs(request: any = {}, sort: any = {}) {
        this.listAgent = [];
        request.offset = this.page_size1 * (this.currentPage1 <= 0 ? 0 : this.currentPage1 - 1);
        request.limit = this.page_size1;
        
        this.userService.list(request).subscribe(res =>{
            if (res.status == 200 && res.error == false) {
                this.listAgent = res.data.list;
                this.totalItem1 = res.data.total;
                var pageString = (this.totalItem1 / this.page_size1).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage1 = totalpage;


            } else {
                this.listAgent = [];
            }
        })
    }

    listTicket(request?: any) {
        this.is_loading = true;
        this.ticketService.status().subscribe(res => {
            let statusList = res.data;
            this.allStatus = statusList;
            let tmp = [{
                id:'',
                text:''
            }];
            statusList.forEach(e => {
                this.tickets[e.id] = [];
                this.totalItem[e.id] = 0;
                this.totalPage[e.id] = 0;
                this.currentPage[e.id] = 1;
                tmp.push({
                    id: e.id,
                    text: e.name
                })
            });
            this.status_select2 = tmp;
            let whereUser = {
                filters : JSON.stringify([
                    {
                        key: 'organize_id',
                        condition : '=',
                        value : this.organize.organize_id
                    }
                ])
            }
            
            this.userService.list(whereUser).subscribe(rs => {
                if (rs.status == 200 && rs.error == false) {
                    let user_ids = [];
                    rs.data.list.forEach(e => {
                        user_ids.push(e._id);
                    });

                    this.total = 0;
                    let option = {
                        key: 'requester_id',
                        condition : 'in',
                        value: user_ids
                    }
                    this.ticketService.ticketsByListStatus(statusList, option).toPromise().then(list => {
                        if (!list) {
                            list = [];
                        }
                        list.forEach(subList => {
                            this.total += subList['data']['total'];
                            statusList.forEach(e => {
                                let check = _.find(subList['data']['tickets'], { status: e.id });
                                if (check) {
                                    this.tickets[e.id] = subList['data']['tickets'];
                                    let tmp_select = {};
                                    this.tickets[e.id].forEach(_t => {
                                        tmp_select[_t._id] = false;
                                    });
                                    this.selected[e.id] = tmp_select;
                                    this.totalItem[e.id] = subList['data']['total'];
                                    var pageString = (this.totalItem[e.id] / this.page_size).toString();
                                    var pageSplit = pageString.split('.');
                                    var last: any;
                                    var totalpage = parseInt(pageSplit[0]);
                                    if (pageSplit.length > 1) {
                                        last = pageSplit[1];
                                        if (parseInt(last) > 0) {
                                            totalpage++
                                        }
                                    }
                                    this.totalPage[e.id] = totalpage;
                                }
                            })
                        });
                        this.is_loading = false;
                    })

                }
            })
        });
    }


    loadData(status, request: any = {}, sort: any = {}) {
        this.tickets[status] = [];
        this.selected[status] = {};
        request.offset = this.page_size * (this.currentPage[status] <= 0 ? 0 : this.currentPage[status] - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.userService.list({organize_id: this.organize.organize_id}).subscribe(rs => {
            if (rs.status == 200 && rs.error == false) {
                let user_ids = [];
                rs.data.list.forEach(e => {
                    user_ids.push(e._id);
                });

                request.filters = JSON.stringify([{
                    key: 'status',
                    condition: '=',
                    value: status
                }, {
                    key: 'requester_id',
                    condition : 'in',
                    value: user_ids
                }]);
                this.ticketService.list(request).toPromise().then(res => {
                    if (res.status == 200 && res.error == false) {
                        this.tickets[status] = res.data.tickets;
                        res.data.tickets.forEach(e => {
                            this.selected[status][e._id]= false;
                        });
                        this.totalItem[status] = res.data.total;
                        var pageString = (this.totalItem[status] / this.page_size).toString();
                        var pageSplit = pageString.split('.');
                        var last: any;
                        var totalpage = parseInt(pageSplit[0]);
                        if (pageSplit.length > 1) {
                            last = pageSplit[1];
                            if (parseInt(last) > 0) {
                                totalpage++
                            }
                        }
                        this.totalPage[status] = totalpage;
        
        
                    } else {
                        this.tickets[status] = [];
                    }
        
                }, err => {
                    this.tickets[status] = [];
                });
            }
        })
    }

    updateOrganize(body) {
        this.organizeService.update(this.organize.organize_id, body).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.toastr.info('Lưu thành công', '', {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right',

                });
                this.comeback.emit({
                    organize_id:this.organize.organize_id
                })
            } else {
                this.toastr.error('Lưu không thành công', '', {
                    timeOut: 1000,
                    positionClass: 'toast-bottom-right'
                });
            }
        }, error => {
            this.toastr.error(error.message[0].message, 'Lưu không thành công', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            this.message = { class: "alert dark alert-danger", content: error.message };
            setTimeout(() => this.message = null, 3000);
        })
    }


    openTicket(ticket: any) {
        this.userService.find({ _id: ticket.requester_id }).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                ticket.request = res.data;
                this.socketService.opentab(ticket, 'ticket', 'edit');
            }
        })
    }

    newTicket() {
        this.socketService.opentab({}, 'ticket', 'new');
    }

    execCall(phone) {
        if(UtilityService.isValidPhoneNumber(phone)){
            this.socketService.execCall(phone);
        } else {
            this.toastr.error('', 'Số điện thoại không hợp lệ', {
              timeOut: 1000,
              positionClass: 'toast-bottom-right'
            });
          }
    }


    changedName() {
        if(this.model.name){
            this.model.name = this.model.name.trim();
        }
        this.updateOrganize({name: this.model.name});
    }

    changedDomain(){
        let name = this.model.name ? this.model.name.trim() : '';
        this.updateOrganize({domain:this.model.domain, name:name});
    }

    addTags() {
        let name = this.model.name ? this.model.name.trim() : '';
        let _tags_arr = [];
        this.model.tags.forEach(t => {
            _tags_arr.push(t.displayValue);
        });
        let _tags = (_tags_arr.length > 0) ? _tags_arr.join(',') : null;
        this.updateOrganize({tags: _tags, name: name});
    }


    changedNote() {
        let name = this.model.name ? this.model.name.trim() : '';
        if (this.model.note && this.model.note.trim() != '') {
            this.updateOrganize({ note: this.model.note.trim(), name: name})
        }
    }

    

    setPage(status, page: number) {
        if (page <= this.totalPage[status]) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage[status]) {
                this.currentPage[status] = page;
                this.loadData(status);
            }
        }
        else {

            page = this.totalPage[status];
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage[status]) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage[status]) {
                    this.currentPage[status] = page;
                    this.loadData(status);
                }
            }
        }
    }

    goPage2(status, toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(status, toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }


    setPage1(page: number) {
        if (page <= this.totalPage1) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage1) {
                this.currentPage1 = page;
                this.getStaffs()
            }
        }
        else {

            page = this.totalPage1;
            $('#inputPage1').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage1) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage1) {
                    this.currentPage1 = page;
                    this.getStaffs();
                }
            }
        }
    }

    goPage21(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage1(toPage);
        }
    }

    _keyPress1(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }


    setPage2(page: number) {
        if (page <= this.totalPage2) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage2) {
                this.currentPage2 = page;
                this.loadUsers()
            }
        }
        else {

            page = this.totalPage2;
            $('#inputPage2').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage2) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage2) {
                    this.currentPage2 = page;
                    this.loadUsers();
                }
            }
        }
    }

    goPage22(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage1(toPage);
        }
    }

    _keyPress2(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/tabs/organize/detail_organize.component.ts